export type GlogauScaleValue = string | null

export interface GlogauScaleOption {
    key: string
    label: string
    ageRange: string
    description: string
    tooltip: string
}

export const GLOGAU_SCALE_OPTIONS: GlogauScaleOption[] = [
    {
        key: 'I',
        label: 'Tipo I',
        ageRange: 'Entre 20 e 30 anos',
        description: 'Sem rugas',
        tooltip: 'Fotoenvelhecimento leve: leve alteração de pigmentação, sem ceratoses, rugas mínimas, pouca ou nenhuma maquiagem.',
    },
    {
        key: 'II',
        label: 'Tipo II',
        ageRange: 'Entre 30 e 40 anos',
        description: 'Rugas em movimento',
        tooltip: 'Fotoenvelhecimento leve a moderado: lentigos senis iniciais visíveis, ceratoses palpáveis mas não visíveis, linhas de expressão paralelas começam a aparecer ao lado da boca, uso de maquiagem leve.',
    },
    {
        key: 'III',
        label: 'Tipo III',
        ageRange: 'Entre 40 e 60 anos',
        description: 'Rugas em repouso',
        tooltip: 'Fotoenvelhecimento avançado: discromia evidente, telangiectasias, ceratoses visíveis, rugas mesmo em repouso, uso constante de maquiagem/base.',
    },
    {
        key: 'IV',
        label: 'Tipo IV',
        ageRange: 'Acima de 60 anos',
        description: 'Somente rugas',
        tooltip: 'Fotoenvelhecimento severo: pele com tom amarelo-acinzentado, histórico de lesões cutâneas actínicas, rugas por toda a pele sem áreas normais, maquiagem não se sustenta mais sobre a pele.',
    },
]

export function findGlogauOption(key: GlogauScaleValue): GlogauScaleOption | null {
    return GLOGAU_SCALE_OPTIONS.find((option) => option.key === key) ?? null
}

export function isGlogauScaleValueEmpty(value: GlogauScaleValue | undefined): boolean {
    return !value
}
